export default __webpack_public_path__ + "img/28f80309b4e32dd773da98a8c0f1317d.png";